module.exports = __webpack_public_path__ + "static/media/lease-truck-program-grid-2.3b96f7ab.jpg";